import React from 'react';

const STORY_TYPES = [
  { value: 'memory', emoji: '\u2764\uFE0F', label: 'Family Memory' },
  { value: 'milestone', emoji: '\uD83C\uDF1F', label: 'Milestone' },
  { value: 'lesson', emoji: '\uD83D\uDCA1', label: 'Life Lesson' },
  { value: 'funny', emoji: '\uD83D\uDE02', label: 'Funny Moment' },
  { value: 'adventure', emoji: '\u2708\uFE0F', label: 'Adventure' },
  { value: 'other', emoji: '\uD83D\uDCD6', label: 'Other' },
];

const StoryTypeGrid = ({ selected, onSelect, accentClasses }) => {
  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
      {STORY_TYPES.map(({ value, emoji, label }) => {
        const isActive = selected === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => onSelect(value)}
            aria-pressed={isActive}
            className={`flex items-center gap-3 w-full text-left p-4 sm:p-3 rounded-xl border-2 cursor-pointer transition-all duration-150 min-h-[56px] ${
              isActive
                ? `${accentClasses.border} ${accentClasses.bg}`
                : 'border-border-gray bg-white'
            }`}
          >
            <span className="text-2xl sm:text-xl flex-shrink-0">{emoji}</span>
            <span className={`text-lg sm:text-base ${
              isActive
                ? `font-semibold ${accentClasses.color}`
                : 'font-normal text-text-medium'
            }`}>
              {label}
            </span>
          </button>
        );
      })}
    </div>
  );
};

export default StoryTypeGrid;
